import axios from 'axios'
const url = process.env.REACT_APP_SERVER_URL;

export const registeration = async (data) => {
  const endpoint = `${url}/v1/auth/register`

  const response = await axios({
    data,
    method: 'POST',
    timeout: 1000 * 60 * 10,
    url: endpoint,
  });

  // console.log('--- ', response);

  return response;


}

export const sign_in = async (data) => {
  const endpoint = `${url}/v1/auth/login`

  const response = await axios({
    data,
    method: 'POST',
    timeout: 1000 * 60 * 10,
    url: endpoint,
  });

  // console.log('--- ', response);

  return response;


}


export const forgotpassword = async (data) => {
  const endpoint = `${url}/v1/auth/forget-password`

  const res = await axios.post(endpoint, data);
  return res;


}